module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "rgba(0,0,0,0.4)"
    }
  }, [_c('h3', {
    staticStyle: {
      "margin-top": "20%",
      "padding": "30px",
      "color": "white"
    }
  }, [_c('center', [_vm._v("Under Construction")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46e5e803"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/under_construction/under_construction.vue
// module id = 810
// module chunks = 1